import React from 'react';
import VeinWordmark from '../ui/VeinWordmark';
import Button from '../ui/Button';

interface FooterProps {
  onOpenUpdates?: () => void;
  hasUnreadUpdates?: boolean;
}

const actionClass = 'text-caption text-vein-text-secondary hover:text-vein-text-primary rounded-sm';

const Footer = ({ onOpenUpdates, hasUnreadUpdates = false }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-16 mb-8 mx-8 bg-white border border-vein-border rounded-xl">
      <div className="px-6 py-4">
        <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
          {/* Left side - Company info */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <VeinWordmark className="h-4 w-auto" />
            <div className="h-4 w-px bg-vein-border-light"></div>
            <span className="text-caption text-vein-text-secondary">© {currentYear} Vein Technologies</span>
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            {onOpenUpdates && (
              <Button variant="bare" onClick={onOpenUpdates} aria-haspopup="dialog"
                aria-label={hasUnreadUpdates ? 'What’s new, unread update' : 'What’s new'} className={actionClass}>
                What’s new{hasUnreadUpdates && <span className="inline-block align-middle ml-1.5 w-1.5 h-1.5 rounded-full bg-vein-red-500" aria-hidden="true" />}
              </Button>
            )}
            <a href="/privacy" className="text-caption text-vein-text-secondary hover:text-vein-text-primary transition-colors">Privacy</a>
            <a href="/terms" className="text-caption text-vein-text-secondary hover:text-vein-text-primary transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
